import * as Types from '../../types';

import { gql } from '@apollo/client';
export type AddressRiskIndicatorFragment = {
  __typename?: 'AddressRiskConnection';
  totalCount: number;
  pageInfo: {
    __typename?: 'PageInfo';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: string | null;
    endCursor?: string | null;
  };
  edges: Array<{
    __typename?: 'AddressRiskEdge';
    node: {
      __typename?: 'AddressRisk';
      id: any;
      riskType: string;
      severity: string;
      description?: string | null;
    };
  }>;
};

export type EntityRiskIndicatorFragment = {
  __typename?: 'EntityRiskConnection';
  totalCount: number;
  pageInfo: {
    __typename?: 'PageInfo';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: string | null;
    endCursor?: string | null;
  };
  edges: Array<{
    __typename?: 'EntityRiskEdge';
    node: {
      __typename?: 'EntityRisk';
      id: any;
      riskType: string;
      severity: string;
      description?: string | null;
    };
  }>;
};

export const AddressRiskIndicatorFragmentDoc = gql`
  fragment AddressRiskIndicator on AddressRiskConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        id
        riskType
        severity
        description
      }
    }
  }
`;
export const EntityRiskIndicatorFragmentDoc = gql`
  fragment EntityRiskIndicator on EntityRiskConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        id
        riskType
        severity
        description
      }
    }
  }
`;
